import styled from "styled-components";
import * as CommonTypes from "../../../types/common.types"
import { countries } from "countries-list";
// icons
import { MdOutlineAssignmentInd } from "react-icons/md";
import { IoIosSend } from "react-icons/io";
import { FaListUl } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { useState } from "react";
import arrayItemCompare from "../../../utils/arrayItemCompare";
import { useAdmin } from "../../../context/admin";
import { mobile } from "../../../styles/responsive";
import { FaTrash } from "react-icons/fa6";
import Checkbox from "../../common/Checkbox";
import { AiOutlineDollarCircle } from "react-icons/ai";
import RemarksNotice, { withRemarks } from "../modals/RemarksNotice";
import gruposDelDia from "../../../utils/gruposDelDia";
import formatCLP from "../../../utils/formatCLP";

interface ListInterface {
    list: CommonTypes.FullTourInfo[]
}

interface TourInterface {
    tour: CommonTypes.FullTourInfo,
    list: CommonTypes.FullTourInfo[]
}

function Tour({tour, list}: TourInterface) {
    const { setAssignTripReservationId, setConfirmDeleteReservationId,
        setEditReservationId, setAssignTripTourId, setReservationDetails,
        setTraspassTripReservationId, setPassengerPlanId, setTraspassTripTourId,
        setCreatePaymentReservationId, setCreateMultiPaymentReservations,
        user
    } = useAdmin()
    const [selectedReservations, setSelectedReservations] = useState<string[]>([])
    // Acción en espera de que la administradora confirme que leyó los remarks de los seleccionados.
    const [remarksNotice, setRemarksNotice] = useState<'assign' | 'traspass'>()
    const selectedWithRemarks = withRemarks(tour.reservations.filter(r => selectedReservations.includes(r.id)))

    const openAction = (action: 'assign' | 'traspass') => {
        if (action === 'assign') {
            setAssignTripReservationId(selectedReservations)
            setAssignTripTourId(tour.id)
        } else {
            setTraspassTripReservationId(selectedReservations)
            setTraspassTripTourId(tour.id)
        }
    }

    // Assign / Traspass: si algún seleccionado trae remark, primero el aviso; si no, directo.
    const startAction = (action: 'assign' | 'traspass') => {
        if (selectedWithRemarks.length > 0) setRemarksNotice(action)
        else openAction(action)
    }

    const selectAll = (tour_id: string) => {
        const reservations = list.find(item => item.id === tour_id)?.reservations.map(item => item.id)
        if (!reservations) return
        if (arrayItemCompare(reservations, selectedReservations)) setSelectedReservations([])
        else setSelectedReservations(reservations)        
    }

    const are_all_assigned = tour.reservations.every(reservation => reservation.trip.id)

    const payMultiple = () => {
        const eligible = tour.reservations.filter(r =>
            selectedReservations.includes(r.id) && r.trip?.id && r.trip.agency.id !== user?.user.agency_id
        )
        if (eligible.length === 0) {
            alert('Selecciona al menos un pasajero con traspaso pendiente (operado por otra agencia) para registrar un pago múltiple')
            return
        }
        setCreateMultiPaymentReservations(eligible)
    }

    return (
        <div className={"tour" + (are_all_assigned ? " closed" : "")}>
            <div className="header">
                <div className="name">
                    <span>
                        {tour.id}
                    </span>
                </div>
                <div className="actions">
                    <button className="assign"
                    title="Assign"
                    onClick={() => startAction('assign')}
                    >
                        <MdOutlineAssignmentInd/>
                    </button>
                    <button className="details"
                    title="Ver detalles"
                    onClick={() => {
                        setReservationDetails(tour.reservations)
                    }}
                    >
                        <FaListUl/>
                    </button>
                    <button className="traspax"
                    title="Traspass"
                    onClick={() => startAction('traspass')}
                    >    
                        <IoIosSend/>
                    </button>
                    <button className="multi-pay"
                    title="Pago múltiple de traspaso"
                    type="button"
                    onClick={payMultiple}
                    >
                        <AiOutlineDollarCircle/>
                    </button>
                </div>
            </div>
            <TableWrapper>
                <Table>
                    <thead>
                        <tr>
                            <th style={{width: '40px'}}>
                                <button
                                className={selectedReservations.length ? arrayItemCompare(selectedReservations, tour.reservations?.map(item => item.id)) ? 'selected-all' : '': ''}
                                onClick={() => selectAll(tour.id)}
                                ></button>
                            </th>
                            <th>Name</th>
                            <th>Nationality</th>
                            <th>Phone</th>
                            <th>Seller / Ally</th>
                            <th>Depart</th>
                            <th>Agency Trip</th>
                            <th>Sale Price</th>
                            <th>Created via</th>
                            <th>Tickets</th>
                            <th>Traspass Price</th>
                            <th>Ticket included</th>
                            <th>Conf. pago</th>
                            <th>Tour paid</th>
                            <th>Ticket paid</th>
                            <th style={{width: '40px'}}></th>
                            <th style={{width: '40px'}}></th>
                            <th style={{width: '40px'}}></th>
                            <th style={{width: '40px'}}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            // Privado: cada grupo es un vehículo. Se listan juntos y numerados para distinguir
                            // dos privados del mismo tour el mismo día; la franja selecciona a todo el grupo.
                            tour.unidad_precio === 'por_vehiculo'
                            ? gruposDelDia(tour.reservations || []).map(grupo => {
                                const ids = grupo.reservas.map(r => r.id)
                                const todos = ids.every(id => selectedReservations.includes(id))
                                return [
                                    <tr className="grupo" key={`grupo-${grupo.numero}`}>
                                        <td>
                                            <button
                                            className={`select ${todos ? 'selected' : ''}`}
                                            title="Seleccionar este grupo"
                                            onClick={() => setSelectedReservations(prev => todos
                                                ? prev.filter(id => !ids.includes(id))
                                                : [...prev.filter(id => !ids.includes(id)), ...ids])}
                                            ></button>
                                        </td>
                                        <td colSpan={18}>Grupo {grupo.numero} · {grupo.reservas.length} {grupo.reservas.length === 1 ? 'pasajero' : 'pasajeros'} · {formatCLP(grupo.total)}</td>
                                    </tr>,
                                    ...grupo.reservas.map(fila)
                                ]
                            })
                            : tour.reservations?.map(fila)
                        }
                    </tbody>
                </Table>
            </TableWrapper>
            {
                remarksNotice &&
                <RemarksNotice
                tourId={tour.id}
                action={remarksNotice}
                reservations={selectedWithRemarks}
                onCancel={() => setRemarksNotice(undefined)}
                onConfirm={() => {
                    openAction(remarksNotice)
                    setRemarksNotice(undefined)
                }}
                />
            }
        </div>
    )

    function fila(reservation: CommonTypes.FullReservation) {
        const isSelected = selectedReservations.find(id => id === reservation.id)
        return (
            <tr key={reservation.id}>
                <td>
                    <button
                    className={`select ${isSelected ? 'selected' : ''}`}
                    onClick={() => {
                        if (selectedReservations.find(id => id === reservation.id)) {
                            const newList = selectedReservations.filter(id => id !== reservation.id)
                            setSelectedReservations(newList)
                        } else setSelectedReservations([...selectedReservations, reservation.id])
                    }}
                    ></button>
                </td>
                <td>{reservation.passenger.name}</td>
                <td>{countries[reservation.passenger.nationality as keyof typeof countries]?.name || reservation.passenger.nationality}</td>
                <td>{reservation.passenger.phone}</td>
                <td>{reservation.passenger.ally?.name || reservation.passenger.seller?.name}</td>
                <td>{reservation.trip?.trip_time}</td>
                <td>{reservation.trip?.agency?.name || reservation.agency.name}</td>
                <td>{reservation.price}</td>
                <td>{reservation.created_via}</td>
                <td>{reservation.tickets}</td>
                <td>{reservation.traspass_price}</td>
                {/* Aliados y vendedores: el modo de las entradas (Incluida / Pagan en parque / Sin entrada / Manual). Las de antes
                    de las entradas automáticas tienen el campo vacío: "Sin entrada" solo si el tour no entra a
                    ningún parque, si no "Sin definir". Admin y web siguen con Yes/No. */}
                <td>{!(reservation.passenger.ally?.id || reservation.passenger.seller?.id) ? (reservation.ticket_included || Number(reservation.tickets) > 0 ? 'Yes' : 'No')
                    : (reservation as any).tickets_manual ? 'Manual'
                    : reservation.ticket_included === true ? 'Incluida'
                    : reservation.ticket_included === false ? 'Pagan en parque'
                    : !(reservation as any).tiene_parques ? 'Sin entrada'
                    : Number(reservation.tickets) > 0 ? 'Manual' : 'Sin definir'}</td>
                <td>
                    <Checkbox
                    containerStyle={{display: 'flex', justifyContent: 'center'}}
                    checked={
                        !reservation.group_id ?
                        reservation.payments_res?.filter(p => p.authorized).reduce((acc, payment) => acc + (payment.amount || 0) + (payment.amount_tickets || 0), 0) >= reservation.price + reservation.tickets
                        :
                        reservation.payments_res?.filter(p => p.authorized).reduce((acc, payment) => acc + (payment.amount || 0) + (payment.amount_tickets || 0), 0) >= reservation.group.reservations.reduce((acc, r) => acc + Number(r.price) + Number(r.tickets), 0)
                    }
                    />
                </td>
                <td>
                    {
                        reservation.trip.id &&
                        reservation.trip?.agency.id !== user?.user.agency_id &&
                        <Checkbox
                        containerStyle={{display: 'flex', justifyContent: 'center'}}
                        checked={reservation.payments?.reduce((acc, payment) => acc + (payment.amount || 0), 0) >= reservation.traspass_price}
                        />
                    }
                </td>
                <td>
                    {
                        reservation.trip.id &&
                        reservation.trip?.agency.id !== user?.user.agency_id &&
                        <Checkbox
                        containerStyle={{display: 'flex', justifyContent: 'center'}}
                        checked={reservation.payments?.reduce((acc, payment) => acc + (payment.amount_tickets || 0), 0) >= reservation.tickets}
                        />
                    }
                </td>
                <td>
                    {
                        (reservation.trip.id && reservation.trip?.agency.id !== user?.user.agency_id) &&
                        <button className="info"
                        onClick={() => {
                            setCreatePaymentReservationId(reservation.id)
                        }}
                        > 
                            <AiOutlineDollarCircle/>
                        </button>
                    }
                </td>
                <td><button className="info" onClick={() => setPassengerPlanId(reservation.passenger_id)}><AiOutlineInfoCircle/></button></td>
                <td><button className="info" onClick={() => setEditReservationId(reservation.id)}><MdEdit/></button></td>
                <td><button className="info" onClick={() => setConfirmDeleteReservationId(reservation.id)}><FaTrash/></button></td>
            </tr>
        )
    }
}

export default function List({
    list
}: ListInterface) {
    return (
        <Main>
            {
                list.map((tour, idx) => {
                    return (
                        <Tour tour={tour} list={list} key={idx}/>
                    )
                })
            }
        </Main>
    )
}

const Main = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 90%;
    margin: auto;
    margin-top: 15px;
    
    ${mobile({
        width: '100%',
        padding: '0 10px'
    })}
    
    overflow: unset;
    
    .tour.closed .header, .tour.closed .sub-header {
        background-color: ${props => props.theme.lightGreen};
        color: ${props => props.theme.white};
    }

    .tour {
        background-color: ${props => props.theme.whiteBackground};
        border-radius: 10px;
        box-shadow: 0 3px 5px ${props => props.theme.blackTransparent};
        
        .header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-radius: 10px 10px 0 0;
            position: relative;
            height: 40px;
            background-color: ${props => props.theme.black};
            color: ${props => props.theme.white};
            
            ${mobile({
                flexDirection: 'column',
                height: 'auto',
                padding: '10px',
                gap: '10px'
            })}
            
            .name {
                flex: 1;
                text-align: center;
                
                ${mobile({
                    textAlign: 'left',
                    width: '100%'
                })}
            }
            
            .actions {
                height: 100%;
                display: flex;
                gap: 5px;
                padding: 5px;
                
                ${mobile({
                    width: '100%',
                    justifyContent: 'center'
                })}
                
                button {
                    height: 100%;
                    width: 50px;
                    font-size: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: none;
                    border-radius: 5px;
                    cursor: pointer;
                    color: ${props => props.theme.white};
                    
                    ${mobile({
                        width: '40px',
                        height: '35px',
                        fontSize: '16px'
                    })}
                }
                
                button.traspax {
                    background-color: ${props => props.theme.blue};
                }
                
                button.details {
                    background-color: ${props => props.theme.yellowDark};
                }
                
                button.assign {
                    background-color: ${props => props.theme.lightGreen};
                }

                button.multi-pay {
                    background-color: ${props => props.theme.greenDark};
                }
            }
        }
    }
`

const TableWrapper = styled.div`
    width: 100%;
    height: 100%;
    overflow-x: auto;
    overflow-y: visible;
    
    ${mobile({
        overflowX: 'scroll',
        '-webkit-overflow-scrolling': 'touch'
    })}
`

const Table = styled.table`
    border-collapse: collapse;
    position: relative;
    height: 100%;
    width: 100%;
    min-width: 1200px;
    
    ${mobile({
        minWidth: '800px'
    })}
    
    thead {
        width: 100%;
        background-color: #FFFFFF;
        position: sticky;
        top: 0;
        z-index: 10;
    }
    
    th {
        font-weight: 500;
        font-size: 13px;
        padding: 12px 8px;
        background-color: #f9fafb;
        border-bottom: 2px solid #e5e7eb;
        white-space: nowrap;
        
        > button {
            width: 20px;
            height: 20px;
            color: #FFF;
            font-size: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
            background-color: ${props => props.theme.white};
            border: 1px solid ${props => props.theme.black};
            border-radius: 5px;
            cursor: pointer;
            transition: transform .3s ease;
            
            &:active {
                transform: scale(0.8);
            }
        }
        
        > button.selected-all {
            background-color: ${props => props.theme.yellowDark};
        }
    }
    
    td {
        text-align: center;
        padding: 10px 8px;
        border-bottom: 1px solid #f0f0f0;
        font-size: 13px;
        white-space: nowrap;
        
        .flag {
            width: 30px;
        }
        
        button.select {
            width: 20px;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
            background-color: ${props => props.theme.white};
            border: 1px solid ${props => props.theme.black};
            border-radius: 5px;
            cursor: pointer;
            transition: transform .3s ease;
            
            &:active {
                transform: scale(0.8);
            }
        }
        
        button.selected {
            background-color: ${props => props.theme.yellowDark};
        }
        
        button.info {
            border: none;
            background: none;
            font-size: 18px;
            cursor: pointer;
            padding: 5px;
            color: ${props => props.theme.blue};
            transition: all 0.2s ease;
            
            &:hover {
                transform: scale(1.1);
            }
        }
    }
    
    tr.grupo td {
        padding: 6px 8px;
        font-weight: 600;
        text-align: left;
        background-color: #e0f2fe;
        color: #075985;
    }

    tr {
        height: auto;
        width: 100%;
        
        &:hover {
            background-color: #f9fafb;
        }
    }
`